module.exports = __webpack_public_path__ + "img/drop-up.7ed20237.svg";